import { ChevronRight, Loader2 } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RootState, useAppDispatch } from "../../../redux/store";
import { setTopNavNameTitle } from "../../../redux/features/mobileLayout/slice";
import { getThisWeekTimeCardSummary } from "../../../redux/features/EmployeeTimeCard";
import { useSelector } from "react-redux";
import { convertDecimalHoursToHM } from "../../../utils/employeeTimeCardhelper";

const TimesheetSummaryTile: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const user = useSelector((state: RootState) => state?.user?.user);
    const { thisWeekSummary, loading } = useSelector(
        (state: RootState) => state.employeeTimeCardData
    );

    useEffect(() => {
        if (user?.os_emp_account_id) {
            dispatch(getThisWeekTimeCardSummary({ employee_id: Number(user.os_emp_account_id) }));
        }
    }, [dispatch, user?.os_emp_account_id]);

    const handleViewTimesheet = () => {
        dispatch(setTopNavNameTitle("My Timesheet"));
        navigate("/m-timesheet", { state: { from: "/mobile-dashboard" } });
    };

    return (
        <div className="p-6 rounded-lg border border-gray-300 bg-white mb-4">
            <div className="flex items-center justify-between">
                <h2
                    className="text-xl font-semibold text-blue-500 leading-none flex items-center"
                    onClick={handleViewTimesheet}
                >
                    My Timesheet
                </h2>
                <ChevronRight className="w-7 h-7 flex-shrink-0 text-blue-500" onClick={handleViewTimesheet} />
            </div>

            <div className="mt-4 grid text-start">
                {loading ? (
                    <div className="flex justify-center py-4">
                        <Loader2 className="w-6 h-6 animate-spin text-blue-600" />
                    </div>
                ) : (
                    <>
                        <div>
                            <p className="text-sm text-gray-500 mb-1">
                                This Week
                            </p>
                            <p className="text-lg font-bold text-gray-700">
                                {convertDecimalHoursToHM(thisWeekSummary?.total_hours ?? 0)}
                            </p>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default TimesheetSummaryTile;
